<template>
  <svg width="45" height="21" viewBox="0 0 45 21" xmlns="http://www.w3.org/2000/svg"><g fill="#0F1010" fill-rule="evenodd"><path d="M17.045 0h3.409v20.455h-3.409zM23.864 6.818h3.409v13.636h-3.409zM44.318 0H30.681v10.227h3.41V3.41h10.227zM13.636 3.41V0H0V20.455H13.636v-3.41H3.41v-5.113h6.818v-3.41H3.41V3.41z"/><rect x="23.864" width="3.409" height="3.409" rx="1.705"/><path d="M37.5 6.818v3.41a3.41 3.41 0 1 1-3.41 3.408h-3.408A6.818 6.818 0 1 0 37.5 6.818z"/></g></svg>
</template>

<script>
export default {
  name: 'eli5-black',
}
</script>
